import { useEffect, useRef } from 'react';
import type { UsePollingByInterval } from './usePollingByInterval.types';

const usePollingByInterval: UsePollingByInterval = (callback, delay) => {
  const callbackRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (delay !== null) {
      const startCallback = () => {
        callbackRef.current = setInterval(() => {
          callback();
        }, delay);
      };
      startCallback();
      return () => clearInterval(callbackRef.current!);
    }
  }, [delay, callback]);
};

export default usePollingByInterval;
